import i18n from '../../config/i18n/i18n';

export const getLanguageCode = (): string => {
  const currentLang = i18n.language;
  return currentLang === 'uk-UA' ? 'uk' : 'en';
};

export const getAcceptLanguageHeader = (): string => {
  const langCode = getLanguageCode();
  return `${langCode},en;q=0.8`;
}; 